import React, { useState } from "react";
import { send } from "emailjs-com";
import "./ContactForm.scss";
import ReCAPTCHA from "react-google-recaptcha";

const ContactForm = () => {
  const serviceID = "contact_service";
  const templateID = "contact_form";
  const publicKey = "zjghbsIIxLLt2pNM3";

  const [isSent, setIsSent] = useState(false);
  const [isNotSent, setIsNotSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);

  const [mail, setMail] = useState({
    from_name: "",
    from_email: "",
    to_name: "Nandun",
    subject: "",
    message: "",
  });

  const ShowCaptcha = (e) => {
    e.preventDefault();
    setShowCaptcha(true);
  };

  const sendEmail = (captchaValue) => {
    setIsLoading(true);

    const params = {
      ...mail,
      "g-recaptcha-response": captchaValue,
    };

    send(serviceID, templateID, params, publicKey)
      .then((response) => {
        // console.log("SUCCESS!", response.status, response.text);
        if (response.status === 200) {
          setIsSent(true);
          setMail({
            from_name: "",
            from_email: "",
            to_name: "Nandun",
            subject: "",
            message: "",
          });
          setTimeout(() => {
            setIsSent(false);
          }, 3000);
          setIsLoading(false);
          setShowCaptcha(false);
        } else {
          setIsNotSent(true);
          setTimeout(() => {
            setIsNotSent(false);
          }, 5000);
          setIsLoading(false);
          setShowCaptcha(false);
        }
      })
      .catch((err) => {
        setIsNotSent(true);
        setTimeout(() => {
          setIsNotSent(false);
        }, 5000);
        setIsLoading(false);
        setShowCaptcha(false);
        console.error("FAILED...", err);
      });
  };

  const handleChange = (e) => {
    setMail({ ...mail, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-form-area">
      <form className="row" onSubmit={ShowCaptcha}>
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="name">Your Name</label>
            <input
              type="text"
              className="form-control form-control-lg"
              name="from_name"
              id="name"
              value={mail.from_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              className="form-control form-control-lg"
              name="from_email"
              id="email"
              value={mail.from_email}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-lg-12">
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              className="form-control form-control-lg"
              name="subject"
              id="subject"
              value={mail.subject}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="col-lg-12">
          <div className="my-3">
            <label htmlFor="message">Your Message</label>
            <textarea
              className="form-control"
              name="message"
              id="message"
              cols={30}
              rows={11}
              value={mail.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
        </div>
        {isSent && (
          <p className="success-message">Message sent successfully..!</p>
        )}
        {isNotSent && (
          <p className="fail-message">
            Message sending failed! Please contact the owner...
          </p>
        )}
        <div className="col my-3">
          <button type="submit" className="btn-main">
            {isLoading && (
              <span
                className="spinner-border spinner-border-sm mx-1"
                role="status"
              ></span>
            )}
            Send Message &nbsp;<i className="bi bi-chevron-right"></i>
          </button>
        </div>
      </form>
      {showCaptcha && (
        <ReCAPTCHA
          sitekey="6LcnS3UiAAAAANJDQGvYUeWfc3XjKY7A_Ebi9kMJ"
          onChange={sendEmail}
        />
      )}
    </div>
  );
};

export default ContactForm;
